import { useEffect, useState } from 'react';

import { isSandbox } from 'sandbox';

import { ICachedShellVersion } from './interfaces';

const STORAGE_KEY = 'shell_version_cache';
const EXPIRE_MS = 3 * 60 * 60 * 1000;
const SHELL_URL = 'https://dl.smartshell.gg/versions.json';

export const useShellVersion = (): string | null => {
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    if (isSandbox) {
      setVersion('sandbox');
      return;
    }

    let isMounted = true;
    let needFetch = true;

    try {
      const cachedRaw = localStorage.getItem(STORAGE_KEY);
      if (cachedRaw) {
        const cached: ICachedShellVersion = JSON.parse(cachedRaw);
        if (Date.now() - cached.timestamp < EXPIRE_MS) {
          setVersion(cached.version);
          needFetch = false;
        }
      }
    } catch {
      // empty
    }

    if (needFetch) {
      fetch(SHELL_URL)
        .then((r) => r.json())
        .then((data) => {
          const v = data?.cloudShell?.version ?? null;

          if (isMounted && v) {
            setVersion(v);
            const save: ICachedShellVersion = {
              version: v,
              timestamp: Date.now(),
            };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(save));
          }
        })
        .catch(() => {
          // empty
        });
    }

    return () => {
      isMounted = false;
    };
  }, []);

  return version;
};
